<!--步骤组件-->
<template>
  <div class="steps">
    <ul>
      <li>
        <img v-if="stepIndex == 1"  class="steps-icon" src="@/assets/pc/icon_customer_blue.svg" alt="">
        <img v-else class="steps-icon" src="@/assets/pc/icon_customer_grey.svg" alt="">

        <p class="text" :class="{ active: stepIndex == 1}">Customer Information</p>
      </li>
      <li class="dot-wrap">
        <div><i class="dot"></i></div>
        <div><i class="dot"></i></div>
        <div><i class="dot"></i></div>
        <div><i class="dot"></i></div>
        <div><i class="dot"></i></div>
      </li>

      <li>
        <img v-if="stepIndex == 2" class="steps-icon" src="@/assets/pc/icon_business_blue.svg" alt="">
        <img v-else class="steps-icon" src="@/assets/pc/icon_business_grey.svg" alt="">
        <p class="text" :class="{ active: stepIndex == 2}">Business Information</p>
      </li>
      <li class="dot-wrap">
        <div><i class="dot"></i></div>
        <div><i class="dot"></i></div>
        <div><i class="dot"></i></div>
        <div><i class="dot"></i></div>
        <div><i class="dot"></i></div>
      </li>

      <li>
        <img v-if="stepIndex == 3" class="steps-icon" src="@/assets/pc/icon_account_blue.svg" alt="">
        <img v-else class="steps-icon" src="@/assets/pc/icon_account_grey.svg" alt="">
        <p class="text" :class="{ active: stepIndex == 3}">Account Information</p>
      </li>


    </ul>
  </div>
</template>

<script>
  export default {
    name: "Steps",
    props: {
      stepIndex: {
        type: [Number, String],
        default: 1
      }
    },

    data() {
      return {

      }
    }
  }
</script>

<style lang="scss" scoped>
  .steps {
    margin-top: 80px;
    .steps-icon {
      width: 61px;
      height: 43px;
    }
    .text {
      text-align: center;
      font-family: PingFangSC-Medium;
      font-size: 13px;
      color: #C1C1BF;
      letter-spacing: 0.07px;
      margin-top: 5px;
      &.active{
        color: #FFCC52;
      }
    }
    .dot-wrap {
      text-align: center;
      margin: 10px 0 10px;
    }
    .dot {
      display: inline-block;
      width: 4px;
      height: 4px;
      background: #C1C1BF;
      border-radius: 50%;
    }
  }
</style>